
export const SET_FILE_LOAD_UPDATE = 'SET_FILE_LOAD_UPDATE';
// export const SET_MODE = 'SET_MODE';
// export const SET_SELECTED_INDEX = 'SET_SELECTED_INDEX';
// export const SET_DRAG_INDEX = 'SET_DRAG_INDEX';
// export const ADD_IMAGE = 'ADD_IMAGE';
// export const DELETE_IMAGE = 'DELETE_IMAGE';
// export const ADD_TEXT = 'ADD_TEXT';
// export const DELETE_TEXT = 'DELETE_TEXT';
export const DUPLICATE_IMAGE = 'DUPLICATE_IMAGE';
export const DUPLICATE_TEXT = 'DUPLICATE_TEXT';
// export const SET_IMAGE_DATA = 'SET_IMAGE_DATA';
// export const UPDATE_IMAGE_DATA = 'UPDATE_IMAGE_DATA';
// export const SET_TEMPLATE_DATA = 'SET_TEMPLATE_DATA';
// export const UPDATE_TEMPLATE_DATA = 'UPDATE_TEMPLATE_DATA';
// export const SET_TEXT_DATA = 'SET_TEXT_DATA';
// export const UPDATE_TEXT_DATA = 'UPDATE_TEXT_DATA';
export const SET_CANVAS_SCALE = 'SET_CANVAS_SCALE';
export const SET_BRUSH_COLOUR = 'SET_BRUSH_COLOUR';
// export const NEW_PROJECT = 'NEW_PROJECT';
// export const APPLY_IMAGE_FILTER = 'APPLY_IMAGE_FILTER';
// export const APPLY_TEMPLATE_FILTER = 'APPLY_TEMPLATE_FILTER';
// export const SHOW_PHONETICS = 'SHOW_PHONETICS';
// export const ADD_PHONETIC = 'ADD_PHONETIC';
export const SET_USER_NAME = 'SET_USER_NAME';
// export const MENU_OPEN = 'MENU_OPEN';
export const SET_SEARCH = 'SET_SEARCH';
export const UNDO = 'UNDO';
export const STORE_HISTORY = 'STORE_HISTORY';
export const SET_CURRENT_DIR = 'SET_CURRENT_DIR';
export const SET_ORIENTATION = 'SET_ORIENTATION';
export const SET_TEMPLATE_LOCK = 'SET_TEMPLATE_LOCK';
export const SHOW_LOADER = 'SHOW_LOADER';
export const FULL_SCREEN = 'FULL_SCREEN';
export const SET_GENERIC = 'SET_GENERIC';